function ErrorBanner({ message, onRetry, retryLabel = "RETRY" }) {
  if (!message) return null;
  return (
    <div
      style={{
        backgroundColor: "rgba(255,68,102,0.1)",
        border: "1px solid rgba(255,68,102,0.3)",
        borderRadius: "6px",
        padding: "12px 16px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <span style={{ color: "#ff4466", fontSize: "12px", lineHeight: "1.5" }}>
        ⚠ {message}
      </span>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            background: "none",
            border: "1px solid rgba(255,68,102,0.4)",
            color: "#ff4466",
            fontWeight: "700",
            fontSize: "10px",
            letterSpacing: "1px",
            padding: "5px 12px",
            borderRadius: "4px",
            cursor: "pointer",
            flexShrink: 0,
            whiteSpace: "nowrap",
          }}
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
}

export default ErrorBanner;
